import { render } from "./WindowTitle.vue?vue&type=template&id=687812f0&scoped=true&ts=true"
import script from "./WindowTitle.vue?vue&type=script&lang=ts"
export * from "./WindowTitle.vue?vue&type=script&lang=ts"

import "./WindowTitle.vue?vue&type=style&index=0&id=687812f0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687812f0"]])

export default __exports__